import { useEffect, useState } from "react";
import { MdOutlineAccountTree, MdOutlineMapsHomeWork } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormCondominios from "../FormCondominios/FormCondominios";
import ListCondominios from "../ListCondominios/ListCondominios";
import "./ConsultaCondominios.css";
import { UnitsFlow } from "../../../components/UnitsFlow/UnitsFlow";
import { FaListUl } from "react-icons/fa";
import { TbBuildingCommunity } from "react-icons/tb";
import Button from "../../../components/Button/Button";
import { BiCog } from "react-icons/bi";
import { useAuth } from "../../../contexts/auth";

const ConsultaCondominios = () => {
	const { user, can } = useAuth();
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const [refreshKey, setRefreshKey] = useState(0);
	const navigate = useNavigate();
	const location = useLocation();
	const [viewMode, setViewMode] = useState("list");

	const canCreate = can?.("bravas.identity.unit.create");

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<TbBuildingCommunity size={20} />}
					title="Organização"
					navigate="../cadastro-condominios"
					buttonLabel="Adicionar"
					hideAddButton={!canCreate}
					aditionalButton1={
						(user.userData?.hasRootUnitAccess || user.userData?.isSuperAdmin) &&
						<Button
							className="button-white w-[150px]!"
							icon={<BiCog size={20} />}
							label="Configurações"
							onClick={() => navigate('../configuracoes/dados-cadastrais')}
						/>
					}
				>
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<div className="view-mode-container">
							<label>
								<input type="radio" name="viewMode" value="list" checked={viewMode === "list"} onChange={() => setViewMode("list")} />
								<span><FaListUl /></span>
							</label>
							<label>
								<input type="radio" name="viewMode" value="flow" checked={viewMode === "flow"} onChange={() => setViewMode("flow")} />
								<span><MdOutlineAccountTree /></span>
							</label>
						</div>
						<SearchInput
							value={searchText}
							placeholder="Buscar"
							onChange={({ target }) => setSearchText(target.value)}
							onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
						/>
					</div>
				</SearchContainer>
				<Container>
					<ListCondominios filters={filters} refreshKey={refreshKey} viewMode={viewMode} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormCondominios condominio={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaCondominios;
